import * as constants from '../constants.js';
import { waitUntil } from './waitUntil.js';
/**
 * Waits for an element's presence in the DOM.
 * Returns immediately if the element is already present.
 *
 * @param selector The element selector
 * @param timeout The time to wait in milliseconds before throwing an error
 */
export function waitForElement(selector, timeout = constants.mutationObserveTimeout) {
    let mutationObserver;
    return waitUntil(() => {
        const deferred = {};
        const element = document.querySelector(selector);
        if (element != null) {
            return Promise.resolve(element);
        }
        mutationObserver = new MutationObserver((_, observer) => {
            var _a;
            const element = document.querySelector(selector);
            if (element != null) {
                observer.disconnect();
                (_a = deferred.resolve) === null || _a === void 0 ? void 0 : _a.call(deferred, element);
            }
        });
        return new Promise(resolve => {
            deferred.resolve = resolve;
            mutationObserver.observe(document, { childList: true, subtree: true });
        });
    }, {
        timeout,
        timeoutMessage: `Timeout while waiting on element "${selector}" to appear.`,
    }).finally(() => {
        mutationObserver === null || mutationObserver === void 0 ? void 0 : mutationObserver.disconnect();
    });
}
//# sourceMappingURL=waitForElement.js.map